/**
* Created by MARCIANO_8
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 09/04/2018.
*
* users-create-view Vue Component
*/
<template>
  <form-modal
    :hide-secondary-button="true"
    primary-button-label="Crear sucursal"
    modal-title="Crear sucursal"
    @closeModal="onCloseModal"
    @primaryButtonClick="onSave">
    <div class="content">
      <branches-form ref="form"/>
    </div>
  </form-modal>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
import FormModal from '@/components/_shared/form-modal'
import BranchesForm from '@/modules/branches/branches-form'
export default {
  name: 'BranchesCreateView',
  components: {FormModal, BranchesForm},
  methods: {
    onCloseModal () {
      this.$router.push({name: 'branches'})
    },
    onSave () {
      this.$refs.form.onSubmit()
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
  .content{
    padding: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/app/branches/branches-create-view.vue